import { render, staticRenderFns } from "./riskSection.vue?vue&type=template&id=15b8f054&scoped=true&"
import script from "./riskSection.vue?vue&type=script&lang=ts&"
export * from "./riskSection.vue?vue&type=script&lang=ts&"
import style0 from "./riskSection.vue?vue&type=style&index=0&id=15b8f054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8f054",
  null
  
)

export default component.exports